<template>
  <settings-card>
    <template v-slot:title>
      <template v-if="connexionType === 0">
              Finalise la création de ton profil
      </template>
      <template v-else>
        Connecte toi
      </template>

    </template>
    <template v-slot:content>
      <div class="logincontent">
        <!--<div v-if="connexionType === 0 && showTitle !== ''">
          Crée-toi un compte pour commencer ton apprentissage avec {{ showTitle }} et suivre ta progression.
        </div>-->
        <div class="pageBody flexwrap centercenter">
          <div id="loginBody" class="smallMargin">
            <div class="form-body">
              <div class="mail-icon smallMargin align-center">
                <i class="fas fa-envelope"></i>
              </div>
              <div id="mail-input" c>
                <form :class="{'form-group-error': $v.mail.$error}"
                      @submit.prevent="validate()"
                      @keydown.enter.prevent="validate()">
                  <input type="email" class="smallRoundAngles smallMargin" placeholder="Email"
                         v-model.trim="$v.mail.$model"
                         @blur="mailBlur = true"
                  />
                </form>
                <div id="mail-errors" class="smallMargin" v-if="!isMobile">
                  <div class="error" :class="[(!$v.mail.required && mailBlur) ? '' : 'invisible']">Le mail est obligatoire.
                  </div>
                  <div class="error" :class="[(!$v.mail.email && mailBlur) ? '' : 'invisible']">Le format mail n'est pas
                    respecté.
                  </div>
                  <div v-for="(message, index) in warningsList.mail" :key="index" class="error">{{ message }}</div>
                </div>
              </div>
              <div class="lock-icon smallMargin align-center">
                <i class="fas fa-lock"></i>
              </div>
              <div id="password-input" class="align-center">
                <form @submit.prevent="validate()"
                      @keydown.enter="validate()">
                  <input type="password" class="smallRoundAngles smallMargin"
                         placeholder="Mot de passe" v-model.trim="$v.password.$model"
                         @blur="passwordBlur = true"
                  >
                </form>
                <div id="password-errors" class="smallMargin" v-if="!isMobile">
                  <div class="error" :class="[(!passwordBlur || $v.password.required) ? 'invisible' : '']">
                    <div v-for="(message, index) in warningsList.password" :key="index" class="error">{{ message }}</div>
                  </div>
                </div>
              </div>
              <div @click="validate()" class="envoyer align-center smallRoundAngles paddingRound smallMargin clickable mediumShadow">
                <div class="flexwrap centercenter">
                  <strong>
                    <span v-if="connexionType === 0">Commencer</span>
                    <span v-else>Se connecter</span>
                  </strong>
                </div>
              </div>
              <div class="or centercenter">
                <strong><span style="text-decoration: line-through">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                  ou
                  <span style="text-decoration: line-through">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></strong>
              </div>
              <div class="social-networks align-center">
                <div @click="loginSocial('google-oauth2')"
                     class="google flexwrap centercenter smallRoundAngles paddingRound smallMargin clickable mediumShadow">
                  <strong>
                    <i class="fab fa-google"></i> Google
                  </strong>
                </div>
                <div @click="loginSocial('facebook')"
                     class="facebook flexwrap centercenter smallRoundAngles paddingRound smallMargin clickable mediumShadow">
                  <strong>
                    <i class="fab fa-facebook-square"></i>
                    Facebook
                  </strong>
                </div>
              </div>
            </div>
            <div id="mobile-errors" v-if="isMobile">
              <div id="mail-errors" class="smallMargin">
                <div class="error" :class="[(!$v.mail.required && mailBlur) ? '' : 'invisible']">Le mail est obligatoire.
                </div>
                <div class="error" :class="[(!$v.mail.email && mailBlur) ? '' : 'invisible']">Le format mail n'est pas
                  respecté.
                </div>
                <div v-for="(message, index) in warningsList.mail" :key="index" class="error">{{ message }}</div>
              </div>
              <div id="password-errors" class="smallMargin">
                <div class="error" :class="[(!passwordBlur || $v.password.required) ? 'invisible' : '']">
                  <div v-for="(message, index) in warningsList.password" :key="index" class="error">{{ message }}</div>
                </div>
              </div>
            </div>
            <div id="password-forgotten" v-if="connexionType === 1">
              <PasswordForgotten></PasswordForgotten>
            </div>
          </div>
        </div>
        <div style="grid-row: 3/4" v-if="connexionType === 1">
          <standard-button color-class="olive" style="margin-left: auto; margin-right: auto; margin-bottom: 2vw" @click="$router.push({name: 'guide'})">
            Je n'ai pas encore de profil
          </standard-button>
        </div>
      </div>
    </template>
  </settings-card>
</template>

<script>
import {required, minLength, email} from 'vuelidate/lib/validators'
import SettingsCard from "@/components/settingsCard";
import standardButton from "@/components/standardButton";
import {mapGetters} from "vuex";


export default {
  name: "login",
  //components: {PasswordChecker},
  props: {
    connexionType: Number,
    showTitle: String
  },

  components: {
    SettingsCard,
    standardButton,
    PasswordForgotten: () => import(/* webpackPrefetch: true */ '@/components/passwordForgotten.vue'),
  },

  created() {
    this.$cookies.set('connexionType', this.connexionType)
    this.$session.set('connexionType', this.connexionType)
  },

  mounted() {
    if(!this.isMobile) {
      document.getElementById('mail-errors').style.left = document.getElementById('mail-input').offsetWidth +'px'
      document.getElementById('password-errors').style.left = document.getElementById('password-input').offsetWidth +'px'
    }
    else {
      document.getElementById('mobile-errors').style.top = document.getElementById('loginBody').offsetHeight +'px'
    }

    if(!this.isMobile) {
      document.getElementById('password-forgotten').style.top = document.getElementById('loginBody').offsetHeight +'px'
    }
    else {
      document.getElementById('password-forgotten').style.top = document.getElementById('loginBody').offsetHeight + document.getElementById('mobile-errors').offsetHeight + 'px'
    }
  },

  updated() {
    if(!this.isMobile) {
      document.getElementById('mail-errors').style.left = document.getElementById('mail-input').offsetWidth +'px'
      document.getElementById('password-errors').style.left = document.getElementById('password-input').offsetWidth +'px'
    }
    else {
      document.getElementById('mobile-errors').style.top = document.getElementById('loginBody').offsetHeight +'px'
    }

    if(!this.isMobile) {
      document.getElementById('password-forgotten').style.top = document.getElementById('loginBody').offsetHeight +'px'
    }
    else {
      document.getElementById('password-forgotten').style.top = document.getElementById('loginBody').offsetHeight + document.getElementById('mobile-errors').offsetHeight + 'px'
    }
  },

  methods: {
    loginSocial(socialMedia) {
      this.$webAuth.authorize({
        connection: socialMedia,
        responseType: 'token',
      }, (err, authResult) => {
        if(!err) {
        }
        else {
          console.log(err)
        }
      });
    },

    validate() {
      if(!this.validateClicked) {
        this.warningsList.mail = []
        this.warningsList.password = []
        if (this.username === '') {
          this.warningMessagesMail = this.warnings.noMail
        }
        if (this.password === '') {
          this.warningMessagesPassword = this.warnings.noPassword
        }
        /*
        if (!this.passwordCheck) {
          this.warningMessagesPassword = this.warnings.password_weak
        }*/
        this.validateClicked = true
        if (this.warningsList['mail'].length === 0 && this.warningsList['password'].length === 0) {
          if (this.connexionType === 0) {
            this.signup();
          } else {
            this.login()
          }
        }
      }
    },

    signup() {
      console.log('signup')
      this.$webAuth.signup({
        connection: 'Username-Password-Authentication',
        email: this.mail,
        username: this.mail,
        password: this.password,
        //user_metadata: {plan: 'silver', team_id: 'a111'}
      }, (err) => {
        if (err) {
          this.validateClicked = false;
          let temp = err;
          if (temp.code === "user_exists") {
            this.warningMessagesMail = this.warnings.user_exists
          }
          return console.log(temp.code);
        }
        else {
          // On fait le patch sur heroku avec le user
          this.login()
        }
      });
    },

    login() {
      this.$webAuth.login({
        realm: 'Username-Password-Authentication',
        username: this.mail,
        password: this.password,
        responseType: 'token id_token'
      }, (err) => {
        this.validateClicked = false;
        let temp = err;
        console.log(err)
        if (temp.code === "access_denied" || temp.code === "invalid_user_password") {
          this.warningMessagesMail = this.warnings.wrongUserOrPassword
        }
      })
    },
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
    warningMessagesMail: {
      get: function () {
        return this.warningsList.mail
      },

      set: function (error) {
        this.warningsList.mail.push(error)
      },
    },

    warningMessagesPassword: {
      get: function () {
        return this.warningsList.password
      },

      set: function (error) {
        this.warningsList.password.push(error)
      },
    },

    getPasswordStatus: function () {
      let message = ''
      if (!this.passwordCheck) {
        message += 'Le mot de passe doit contenir au moins : ' + '<ul>'
        if (!this.has_minimum_length) {
          message += '<li>' + this.$v.password.minLength + ' caractères.' + '</li>'
        }
        if (!this.has_special) {
          message += '<li>' + '1 caractère spéciale' + '</li>'
        }
        if (!this.has_number) {
          message += '<li>' + '1 chiffre' + '</li>'
        }
        if (!this.has_uppercase) {
          message += '<li>' + '1 majuscule' + '</li>'
        }
        if (!this.has_lowercase) {
          message += '<li>' + '1 minuscule' + '</li>' + '</ul>'
        }
      }
      return message
    },

    passwordCheck: function () {
      if (this.has_minimum_length && this.has_number && this.has_lowercase && this.has_uppercase && this.has_special) {
        return true
      }
      return false
    },

    has_minimum_length: function () {
      return this.password.length >= 8
    },
    has_number: function () {
      return /\d/.test(this.password)
    },
    has_lowercase: function () {
      return /[a-z]/.test(this.password)
    },
    has_uppercase: function () {
      return /[A-Z]/.test(this.password)
    },
    has_special: function () {
      return /[!@#\$%\^\&*\)\(+=._-]/.test(this.password)
    },
  },

  watch: {},


  data: function () {
    return {
      mail: '',
      password: '',
      mailBlur: false,
      passwordBlur: false,
      warnings: {
        noMail: "L'email est obligatoire",
        noPassword: "Le mot de passe est obligatoire",
        password_weak: "Ton mot de passe est trop faible",
        user_exists: "Cet email est déjà utilisé.",
        wrongUserOrPassword: "Mauvaise combinaison mail / mot de passe."
      },
      warningsList: {
        mail: [],
        password: [],
      },
      //passwordCheck: false,
      validateClicked: false,

    }
  },

  validations: {
    mail: {
      email,
      required,
    },
    password: {
      required,
      minLength: minLength(8),
      has_minimum_length: function () {
        return this.has_minimum_length
      },
      has_number: function () {
        return this.has_number
      },
      has_lowercase: function () {
        return this.has_lowercase
      },
      has_uppercase: function () {
        return this.has_uppercase
      },
      has_special: function () {
        return this.has_special
      },
    }
  }
}
</script>

<style scoped>
.logincontent{
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr auto;
  justify-content: center;
  grid-gap: 2vw;
}

.pageBody {
  z-index: 1;
  width: 20vw;
  flex-direction: column;
}

#loginLogo{
  height: 5vw;
}

.invisible {
  display: none;
}

.message {
  width: 100%;
  text-align: justify;
}

#loginBody {
  width: fill-available;
  position: relative;
}

.form-body {
  display: grid;
  grid-template-rows: auto auto auto auto;
  grid-template-columns: max-content 1fr;
}

.mail-icon {
  width: max-content;
  grid-column: 1/2;
  grid-row: 1/2;
}

#mail-input {
  width: auto;
  position: relative;
  grid-column: 2/3;
  grid-row: 1/2;
}

.justify-right {
  margin-left: auto;
}

.align-center {
  align-self: center;
}

.lock-icon {
  width: max-content;
  grid-column: 1/2;
  grid-row: 2/3;
}

#password-input {
  width: fill-available;
  position: relative;
  grid-column: 2/3;
  grid-row: 2/3;
}

#mail-errors {
  width: 10vw;
  position: absolute;
  top: 0;
}

#password-errors {
  width: max-content;
  position: absolute;
  top: 0;
}

.password-rule-check {
  display: none;
  color: blue;
  list-style-type: '✓ ';
}

.password-tooltip {
  background-color: #3b5998;
  color: #d44337;
}

.envoyer {
  width: fill-available;;
  grid-column: 2/3;
  grid-row: 3/4;
  background-color: var(--goalBackgroundColor);
  color: var(--goalColor);
}

.or {
  justify-self: center;
  grid-column: 2/3;
  grid-row: 4/5;
}

.social-networks {
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column: 2/3;
  grid-row: 5/6;
}

.facebook {
  background-color: #3b5998;
  color: var(--goalColor);
}

.google {
  background-color: #e8233a;
  color: var(--goalColor);
}

input {
  width: fill-available;
  font-size: 1vw;
  border: 1px solid silver;
  background: whitesmoke;
  padding: 5px 10px;
}

input:focus {
  background: white;
}

.dirty {
  border-color: #5A5;
  background: #EFE;
}

.dirty:focus {
  outline-color: #8E8;
}

.error {
  color: var(--goalBackgroundColor2);
  font-size: 0.9vw;
  font-weight: bold;
}

.error:focus {
  outline-color: #F99;
}

/*
.form-group-error {
  animation: shake 0.82s cubic-bezier(.36, .07, .19, .97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}*/

ul{
  list-style-type: none;
  padding-left: 0;
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}

#password-forgotten {
  position: absolute;
  top: 0px;
  left: 0px;
}

@media screen and (max-device-width: 767px) {
  #loginLogo{
    height: 20vw;
  }
  .pageBody {
    width: 90vw;
    max-height: fit-content;
    height: fit-content;
    min-height: fit-content;
    border-radius: 10vw;
    padding: 5vw;
  }

  #loginBody {
    position: relative;
    margin-left: -2vw;
    margin-right: 2vw;
  }

  .form-body {
    display: grid;
    grid-template-rows: auto auto auto auto auto;
    grid-template-columns: max-content fill-available;
  }

  .message {
    width: 100%;
    color: var(--goalColor);
    font-size: 1.3em;
    text-align: left;
    margin-bottom: 5vw;
  }

  input {
    width: fill-available;
    font-size: 4vw;
    border: 1px solid silver;
    background: whitesmoke;
    padding: 5px 10px;
  }

  .error {
    font-size: 4vw;
    color: var(--goalBackgroundColor2);
  }


  #mobile-errors {
    position: absolute;
    left: 0px;
  }
  #mail-errors {
    position: relative;
    width: max-content;
    grid-column: 1/3;
    grid-row: 5/6;
  }

  #password-errors {
    position: relative;
    width: max-content;
    grid-column: 1/3;
    grid-row: 5/6;
  }
}

</style>